import { Nav } from '@accedo/spatial-nav';
import { Image } from '@accedo/ctv-image';
import { FunctionalComponent } from 'preact';
import { stylesheet } from 'astroturf';
import { handleVideoClick } from '##/utils/TileClickHandlers';
import { ComponentTypes } from '##/utils/types';
import { PageNavigation } from '##/utils/PageNavigation';
import { focusCache } from '##/services/store/store';
import { addProgressToEpisodes } from '##/utils/ContinueWatchingUtil';
import { BaseCarousel, CarouselData } from '../BaseCarousel/BaseCarousel';
import StandardCarouselTile from '../StandardCarousel/StandardCarouselTile';
import { StandardCarouselItem } from '../StandardCarousel/types';
import { FeaturedCarouselData, FeaturedShowItem } from './types';
import { FeaturedShowTile } from './FeaturedShowTile';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .featured-carousel-container {
    width: 100vw;
    height: 87.5vh;
    margin-top: 10vh;
    margin-bottom: 6vh;
    position: relative;
  }

  .standard-carousel-wrapper {
    position: absolute;
    bottom: 4.75vh;
    padding-left: pxToVw(125);
    margin-top: 5vh;
  }

  .feature-image {
    width: 100%;
  }

  .featured-image-container {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    overflow: hidden;
  }
`;

export const FeaturedCarousel: FunctionalComponent<FeaturedCarouselData> = (
  props,
) => {
  const fallbackUrl = '/assets/placeholders/Fallback-FeaturedBG.jpg';

  const isShowCarousel = props.items.find((item) => item.type === 'Show');

  const items = isShowCarousel
    ? (props.items as FeaturedShowItem[])
        .filter((item) => item.numberOfEpisodes > 0 || item.numberOfExtras > 0)
        .map((item) => ({
          ...item,
          description: item.numberOfEpisodes
            ? `${item.numberOfEpisodes} Episodes`
            : `${item.numberOfExtras} Extras`,
        }))
    : addProgressToEpisodes(props.items as StandardCarouselItem[]);

  const onTileClick = isShowCarousel
    ? (tileData: FeaturedShowItem) => {
        if (tileData.apiEndpoint) {
          if (!tileData.numberOfEpisodes) {
            focusCache.tvShowDetails.$set({ isExtra: true });
          }
          PageNavigation.navigateTo(`/show/${tileData.id}`, tileData);
        }
      }
    : handleVideoClick;

  const Tile = isShowCarousel ? FeaturedShowTile : StandardCarouselTile;

  const carouselData: CarouselData = {
    id: `${props.id}-featured`,
    index: props.index,
    title: props.title,
    items,
    isInbound: props.isInbound,
    onTileClick,
    scrollEndBoundary: 3,
    Tile,
    type: ComponentTypes.Featured,
  };

  return (
    <div className={styles.featuredCarouselContainer} id={props.id}>
      <Nav.Vertical id={props.id}>
        <div className={styles.featuredImageContainer}>
          <Image
            url={
              `${props.imageUrl}?image-profile=fetch_showpage_hero` ||
              fallbackUrl
            }
            className={styles.featureImage}
            fallbackUrl={fallbackUrl}
          />
        </div>
        <div className={styles.standardCarouselWrapper}>
          <BaseCarousel {...carouselData} />
        </div>
      </Nav.Vertical>
    </div>
  );
};
